import { render, staticRenderFns } from "./ImportFulfillmentsModal.vue?vue&type=template&id=1f45b630&"
import script from "./ImportFulfillmentsModal.vue?vue&type=script&lang=js&"
export * from "./ImportFulfillmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports